/* @flow */

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import {
  getPageById,
  getPendingPageById,
  getIsUpdating,
  hasContentUpdate,
} from 'catalog/reducers/pages';
import * as PagesActions from 'catalog/actions/pages';
import { getSecurityComponent } from 'catalog/plugin';
import SecureHeader from './components/SecureHeader';
import PendingChangesPrompt
  from 'catalog/screens/shared/components/PendingChangesPrompt';

type Props = {
  page?: CatalogPage,
  pendingPage?: CatalogPage,
  isUpdating: boolean,
  hasUpdate: boolean,
  serialize: (page: CatalogPage) => void,
  cancelPending: (page: CatalogPage) => void,
  update: (page: CatalogPage) => void,
};

const styles = {
  container: {
    marginTop: '1rem',
  },
};

const mapStateToProps = (state, { match: { params: { id } } }) => ({
  page: getPageById(state, id),
  pendingPage: getPendingPageById(state, id),
  isUpdating: getIsUpdating(state),
  hasUpdate: hasContentUpdate(state, id),
});

class Secure extends Component {
  props: Props;

  componentWillUnmount() {
    const { page, hasUpdate, cancelPending } = this.props;

    // Don't forget to clear pending changes when leaving
    if (hasUpdate) {
      cancelPending(page);
    }
  }

  render() {
    const {
      page,
      pendingPage,
      isUpdating,
      hasUpdate,
      serialize,
      update,
    } = this.props;

    if (page) {
      const serializeSecurity = security =>
        serialize({
          ...pendingPage,
          security,
        });

      const renderContent = () => {
        const component = getSecurityComponent(pendingPage);
        if (component) {
          return React.cloneElement(component, {
            onUpdate: serializeSecurity,
          });
        }

        return (
          <Message
            icon="info"
            header="Aucun contexte de sécurité"
            content={`Le contexte de sécurité n'est pas configurable sur cette page`}
          />
        );
      };

      const confirm = () => update(page);

      return (
        <div style={styles.container}>
          <SecureHeader
            page={page}
            hasUpdate={hasUpdate}
            isUpdating={isUpdating}
            onConfirm={confirm}
          />
          {renderContent()}
          <PendingChangesPrompt visible={hasUpdate} />
        </div>
      );
    }

    return null;
  }
}

export default compose(
  connect(mapStateToProps, {
    serialize: PagesActions.serializePage,
    update: PagesActions.updatePage,
    cancelPending: PagesActions.cancelPending,
  }),
  withRouter
)(Secure);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Secure/index.js